import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import api from '@/request/api'
import tools from '../utils/tools'
// import * as Sentry from '@sentry/browser';
Vue.use(VueRouter)

const routes = [
    // {
    //     //主体
    //     path: '/',
    //     component: () => import('@/views/index'),
    //     meta: {
    //         pageTitle: '首页', // document.title
    //         // contentTitle: 'logo', // Header中间 , 页面title 当值为logo时显示图标
    //         level: 1, //层级 顶级为1  例如 个人中心为1 消息中心为2 消息详情页为3 以此类推    2左边显示左箭头,3左边显示x
    //         // hasTabBar: true, //是否显示 底部导航菜单 不写不显示
    //         showRight: true, //是否显示Header右侧部分
    //         sign: false, // 页面是否需要登录
    //         type: 'no', //header样式主题 , no-白底黑字正常主题 , yellow-金底白字主题
    //         showHeader: true // 是否显示Hedaer,默认true. false-则隐藏整个Header (注:左侧滑出菜单也在Header中,Header隐藏时,其不可用)
    //     }
    // },
    {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/home'),
        meta: {
            pageTitle: '首页',
            level: 1,
            showRight: true,
            sign: false
        },
        children: [
            {
                path: '/adminuser-list',
                name: 'adminuserList',
                component: () => import('@/views/administratorManagement/adminuserList.vue'),
                meta: {
                    pageTitle: '管理员列表',
                    level: 1,
                    showRight: true,
                    sign: false
                }
            },
            {
                path: '/user-list',
                name: 'userList',
                component: () => import('@/views/userManagement/userList.vue'),
                meta: {
                    pageTitle: '用户列表',
                    level: 1,
                    showRight: true,
                    sign: false
                }
            },
            {
                path: '/usdt-droporder-list',
                name: 'usdtDroporderList',
                component: () => import('@/views/usdt/droporderList.vue'),
                meta: {
                    pageTitle: 'USDT掉单拉回',
                    level: 1,
                    showRight: true,
                    sign: false
                }
            },
            {
                path: '/sm-code-list',
                name: 'smCodeList',
                component: () => import('@/views/smCode/smCodeList.vue'),
                meta: {
                    pageTitle: '手机验证码',
                    level: 1,
                    showRight: true,
                    sign: false
                }
            },
            {
                path: '/bank-list',
                name: 'bankList',
                component: () => import('@/views/banks/bankList.vue'),
                meta: {
                    pageTitle: '用户提现银行卡',
                    level: 1,
                    showRight: true,
                    sign: false,
                    nokeepAlive: true
                }
            }
        ]
    },
    {
        //登陆相关
        path: '/',
        component: () => import('@/views/login/login'),
        name: 'justLogin',
        meta: {
            pageTitle: '登陆',
            level: 3,
            showRight: false,
            sign: false,
            showHeader: false
        }
    },
    {
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})
function dailySignin(LoginData) {
    //领取登陆奖励
    Vue.prototype.$modal({
        type: 'success',
        icon: 'none',
        classname: 'login-modal',
        content: `<div class="trophy"></div><div class='level curren'>
	尊敬的<span>VIP${LoginData.currentlevel}</span>用户，您已获得登录奖励</div><div class='level'><span class='currentWeekRights'>
		${LoginData.signin_bonus}</span><span class="color">元</span></div></div><div class='level todate'>
		明日登录奖励${LoginData.signin_bonus}元
	</div><div class='level textlevel'> 升级至VIP${LoginData.nextlevel}每天即可领取${LoginData.nextsignin_bonus}元</div>`
    })
}
function lvPop(pops, arrStrs) {
    //vip升级弹窗
    Vue.prototype.$modal({
        type: 'success',
        icon: 'none',
        classname: 'upgradepopup',
        successBtnText: '确定',
        content: `
			<div class="tit">
				恭喜您<br>升级为 VIP${pops['1'][0].level}
			</div>
			<p class="tit2">您将享受如下特权</p>
			<p class="tit3">立即到账 ${
                pops['1'][0].amount.includes('.') ? pops['1'][0].amount.split('.')[0] : pops['1'][0].amount
            }元 现金礼包</p>
			<ul class="rights">
				${arrStrs.join('')}
			</ul>
			`,
        // ${arrStrs.join('')}
        customSure: () => {
            api.msg.updateuserpop({ id: pops['1'][0].id }).then(res => {
                console.log(res.data.msg)
            })
        }
    })
}

/**
 * 前置钩子
 * @Params to: 跳转路由  from：当前离开的路由 next：进行通过的钩子函数
 * 参数： 1无参数表示通过 2:false 中断当前导游 3:{path:'/'} 指定页面
 */
router.beforeEach((to, from, next) => {
    // console.log("前往的路由地址"+to.path);
    // 设置网页标题
    document.title = to.meta.pageTitle
    // 异步鉴权
    // if (to.meta.sign) {
    // store.dispatch("User/authUserCheckLogin");
    let type = tools.getBeviceType() //机器类型
    let a = {
        inapp: 2
    }
    if (type !== 'h5') {
        a.inapp = 1
    }
    // api.user.checklogin(a).then(res => {
    // 	let obj = {
    // 		user: res.data,
    // 	};
    // 	store.commit('User/upDataUserInfo', obj);
    // 	if (res.status == '240000001') {
    // 		//登陆状态正常
    // 		//更新用户信息
    // 		let user = store.state.User;
    // 		let pops = res.data.pops;
    // 		if (user.hasLogged && !user.isTestAccount) {
    // 			//正式用户
    // 			if (user.userInfo.user.target_daily_signin == 1) {
    // 				//1-开启了登陆领奖
    // 				if (user.userInfo.user.is_signin == 0) {
    // 					//登陆奖励领取状态 0-未领取 - 弹出登陆奖励框
    // 					dailySignin(user.userInfo.user);
    // 				}
    // 			}
    // 			if (!(pops instanceof Array)) {
    // 				//有弹框数据,1vip升级弹窗/2红包发放弹窗/3域名申请记录弹窗/4活动id=6/5活动id=14 , 目前只处理1
    // 				if (pops['1'] && pops['1'][0] && pops['1'][0].enable == '1') {
    // 					//pops['1']-array-只显示第一个弹窗
    // 					let arrStrs = Object.values(res.data.user_control)
    // 						.map(it => it.show_name)
    // 						.map(it => {
    // 							return `<li><s></s><p>${it}</p></li>`;
    // 						});
    // 					lvPop(pops, arrStrs);
    // 				} else if (pops['2'] && pops['2'][0]) {
    // 					showRed(pops['2'][0]);
    // 				}
    // 			}
    // 		}
    // 	} else {
    // 		//登陆不正常,且需要异步鉴权,则跳登陆,否则不做处理
    // 		if (to.meta.sign) {
    // 			router.push({ name: 'justLogin' });
    // 		}
    // 	}
    // });
    // }
    // 缓存页面设置--废弃
    // if (from.name && to.meta.l > from.meta.l) {
    // 	if (store.state.Game.cachePages.indexOf(from.name) == -1) {
    // 		store.commit("setCachePages", from.name);
    // 	}
    // }
    setTimeout(() => {
        next()
    })
})

/**
 * 后置钩子
 * @Params to: 跳转路由  from：当前离开的路由
 */
router.afterEach((to, from) => {
    // if (from.name && to.meta.l <= from.meta.l) {
    // 	setTimeout(() => {
    // 		store.commit("delCachePages", from.meta.l - to.meta.l);
    // 	}, 200);
    // }
    // setTimeout(() => {
    // 	if (!window.cordova) {
    // 		document.getElementById('tj_script') && document.getElementById('tj_script').remove();
    // 		document.getElementById('site_count_script') && document.getElementById('site_count_script').remove();
    // 		let domian = '';
    // 		let $nodes = '';
    // 		if (location.host.indexOf(':') > 0) {
    // 			domian = location.host.split(':')[0];
    // 		} else {
    // 			domian = location.host;
    // 		}
    // 		let host = domian.split('.');
    // 		if (host.length == 3) {
    // 			host.shift();
    // 			$nodes = host.join('.');
    // 		} else {
    // 			$nodes = location.host;
    // 		}
    // 		let scriptNode = document.createElement('script');
    // 		let scriptNode2 = document.createElement('script');
    // 		scriptNode.type = 'text/javascript';
    // 		scriptNode2.type = 'text/javascript';
    // 		scriptNode.id = 'tj_script';
    // 		scriptNode2.id = 'site_count_script';
    // 		scriptNode.src = `${process.env.VUE_APP_TJURL}${$nodes}.js`;
    // 		scriptNode2.src = process.env.VUE_APP_SITE_COUNT;
    // 		document.getElementsByTagName('HEAD')[0].appendChild(scriptNode);
    // 		document.getElementsByTagName('HEAD')[0].appendChild(scriptNode2);
    // 	}
    // }, 0);
})

export default router
